<template>
    <div class="payResult">
        <div class="tips successed" v-if="item.payresult==1">
            <van-icon name="checked"/>
            <div class="tip">您的订单购买成功，快去{{item.doname}}吧！</div>
        </div>
        <div class="tips failed" v-else>
            <van-icon name="clear"/>
            <div class="tip" v-if="this.errMsg.msg">{{this.errMsg.msg}}</div>
            <div class="tip" v-else>您的订单待确定</div>
        </div>
        <div class="btn" v-if="!this.errMsg.msg">
            <van-button type="info" size="large" @click="handelStudyView" v-if="item.payresult==1">{{item.doname}}</van-button>
            <van-button type="info" size="large" @click="handelarginPay" v-else>重新购买</van-button>
            <van-button type="default" size="large" @click="handelCourseView">查看{{item.kmcname}}详情</van-button>
        </div>
    </div>
</template>

<script>
  import {queryorderpayresult} from 'api/systemApi'
  export default {
    name: 'payResult',
    data() {
      return {
        param: {
          result: this.$route.query.result ? this.$route.query.result : '',
          orderid: this.$route.query.orderid ? this.$route.query.orderid : '',
          rid: this.$route.query.rid ? this.$route.query.rid : '',
          sign: this.$route.query.sign ? this.$route.query.sign : '',
        },
        item: {
          payresult: '', // 1 成功 0 失败
          kmctype: '' // 7 课程 8 题库 2 报告
        },
        courseid: '',
        errMsg: {
          msg: ''
        }
      }
    },
    mounted() {
      this.getCourseid()
    },
    methods: {
      handelCourseView() {
        switch (this.item.kmctype) {
          case 7:
            this.$router.push({name: 'MCourseView', query: {cid: this.courseid, active: 1}})
            break
          case 8:
            if (this.courseid.indexOf('jjcy') > -1) {
                this.$router.push({name: 'QuestionList', query: {code: 'jjcy'}})
            } else {
                this.$router.push({name: 'PaperDetails', query: {qid: this.courseid, active: 0}})
            }
            break
          case 2:
            this.$router.push({name: 'MReportDetails', query: {reportid: this.courseid, active: 0}})
            break
          case 3://直播
            this.$router.push({name: 'MliveDetails', query: {liveid: this.courseid, active: 0}})
            break
        }
      },
      handelarginPay() {
        this.$router.push({name: 'MOrderView', query: {orderno: this.orderno}})
      },
      handelStudyView() {
        switch (this.item.kmctype) {
          case 7:
            this.$router.push({name: 'MCourseView', query: {cid: this.courseid, active: 0}})
            break
          case 8:
            if (this.courseid.indexOf('jjcy') > -1) {
                this.$router.push({name: 'QuestionList', query: {code: 'jjcy'}})
            } else {
                this.$router.push({name: 'PaperDetails', query: {qid: this.courseid, active: 0}})
            }
            break
          case 2:
            this.$router.push({name: 'MReportDetails', query: {reportid: this.courseid}})
            this.setRefresh(true);
            break
          case 3:
            this.$router.push({name: 'MliveDetails', query: {liveid: this.courseid}})
            this.setRefresh(true);
            break
        }
      },
      getCourseid() {
        queryorderpayresult({
          data: this.param,
          success: data => {
            switch (data.data.kmctype) {
              case 7: 
                data.data.doname = '马上学习'
                data.data.kmcname = '课程'
                break
              case 8: 
                data.data.doname = '进入考试'
                data.data.kmcname = '题库'
                break
              case 2: 
                data.data.doname = '查看报告'
                data.data.kmcname = '报告'
                break
              case 3: 
                data.data.doname = '查看直播'
                data.data.kmcname = '直播'
                break
            }
            this.courseid = data.data.courseid
            this.item = data.data
          },
          error: data => {
            this.errMsg.msg = data.msg
            // this.$toast.fail(data.msg)
          }
        })
      }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";

    .payResult {
        padding: 1.4rem 0.32rem 0 0.32rem;
        background: $c-white;
        min-height: 100vh;
        .tips {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            font-size: 1.3rem;
            .tip {
                font-size: 0.32rem;
                margin-top: 0.48rem;
                color: $c-black;
            }
        }
        .successed {
            color: $c-green;
        }
        .failed {
            color: $c-red;
        }
        .btn {
            margin-top: 0.5rem;
            box-sizing: border-box;
            width: 100%;
            padding: 0 0.32rem 0.48rem 0.32rem;
            .van-button--large {
                height: 0.8rem;
                border-radius: 0.04rem;
                font-size: 0.3rem;
                line-height: 1;
            }
            .van-button--default {
                color: $c-blue;
                border-color: $c-blue;
            }
            .van-button + .van-button {
                margin-top: 0.48rem;
            }
        }
    }
</style>